
import { Button, Input, Space, Select, Checkbox } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import WidgetSelector from '../Selectors/WidgetSelector';

const getColumnSearchProps = (dataIndex, dataFilter, setDataFilter, getData, type = "text") => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
            style={{
                padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Input

                placeholder={`Search ${dataIndex}`}
                value={dataFilter}
                onChange={(e) => setDataFilter(e.target.value)}
                onPressEnter={() => getData()}
                style={{
                    marginBottom: 8,
                    display: 'block',
                }}
                type={type}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => getData()}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => { setDataFilter("") }}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        close();
                    }}
                >
                    close
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered) => (
        <SearchOutlined
            style={{
                color: filtered ? '#1677ff' : undefined,
            }}
        />
    ),
    onFilter: (value, record) =>
        record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),

});

export const getDropdownSearchProps = (dataIndex, options, changeValues, placeHolder, getData) => ({
    filterDropdown: ({ close }) => (
        <div
            style={{
                padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Select
                style={{
                    width: '100%',
                    marginBottom: 8,
                    display: 'block',
                }}
                placeholder={placeHolder}
                onSelect={(val, option) => changeValues(dataIndex, option)}
                options={options}
                showSearch={true}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                allowClear
                onClear={() => changeValues(dataIndex, { value: 0, label: '' })}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => getData()}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => { changeValues(dataIndex, { value: 0, label: '' }) }}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        close();
                    }}
                >
                    close
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered) => (
        <SearchOutlined
            style={{
                color: filtered ? '#1677ff' : undefined,
            }}
        />
    ),

});

export const getCheckboxFilterProps = (dataIndex, options, selectedKeys, changeValues, getData) => ({
    filterDropdown: ({ close }) => (
        <div
            style={{
                padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Checkbox.Group
                options={options}
                value={selectedKeys}
                onChange={(values) => changeValues(dataIndex, values)}
                style={{ display: 'block', marginLeft: 0 }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => {
                        getData();
                    }}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => {
                        changeValues(dataIndex, []);
                    }}
                    size="small"
                    style={{
                        width: 90,
                    }}
                >
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        close();
                    }}
                >
                    close
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered) => (
        <SearchOutlined
            style={{
                color: filtered ? '#1677ff' : undefined,
            }}
        />
    ),
});

export default getColumnSearchProps;
